import WorkspaceModel from 'models/WorkspaceModel';

WorkspaceStore.dispatchToken = MakeShiftEmployeeDispatcher.register(WorkspaceStore.dispatchCallback);

WorkspaceStore.onWorkspaceLookupSuccess = function (collection, response) {
  // Extract workspace configuration from response
  const workspaceConfig = response.data || response;

  Utils.setWorkspaceConfig(workspaceConfig);
  Utils.applyWorkspaceTheme();

  WorkspaceStore.trigger('workspace:lookup:success', workspaceConfig);
};

WorkspaceStore.onWorkspaceLookupError = function (collection, error) {
  // Trigger error event for components to handle
  WorkspaceStore.trigger('workspace:lookup:error', error);
};
